import { ResponseCode } from './../../../../gestao-de-concurso/api/model/responseCode';
import { Component, OnInit, inject, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService, MenuItem, ConfirmationService } from 'primeng/api';
import { GrupoPermissoesService } from '../../api/services/grupo-permissoes.service';
import { Pagination } from '@app/shared/model';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { SelectModule } from 'primeng/select';
import { map, take, finalize } from 'rxjs/operators';
import { ApiService } from '@core/providers/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { AuthService } from '@core/service/auth.service';
import { PasswordModule } from 'primeng/password';

interface UserRecord {
  id: string;
  nome: string;
  username: string;
  email: string;
  genero: string;
}

interface GroupOption {
  id: string;
  nomeGrupo: string;
}

@Component({
  selector: 'app-lista-users',
  standalone: true,
  imports: [
    CommonModule,
    SearchBarComponent,
    DataVoidComponent,
    DialogModule,
    InputTextModule,
    ButtonModule,
    ReactiveFormsModule,
    ToastModule,
    TableComponent,
    ConfirmDialogModule,
    SelectModule,
    PasswordModule,
  ],
  providers: [MessageService, ApiService, ConfirmationService],
  templateUrl: './lista-users.component.html',
  styleUrls: ['./lista-users.component.scss'],
})
export class ListaUsersComponent implements OnInit {
  pagination = new Pagination<UserRecord>();
  isLoading = false;
  showFilter = false;
  showModalAssociate = false;
  ShowRecoveryPassword = false;
  ShowNewUser = false;
  associateForm!: FormGroup;
  dissassociateForm!: FormGroup;
  form!: FormGroup;
  formNewUser!: FormGroup;
  formRecoveryPassword!: FormGroup;
  listGrupos: GroupOption[] = [];
  listGroupsByUser: GroupOption[] = [];
  selectedUser?: UserRecord;
  users: any;
  userName: string = '';
  @Output() totalRecordsChange = new EventEmitter<number>();
  private authService = inject(AuthService);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  private permissionService = inject(GrupoPermissoesService);

  private readonly FILTER_ROLE = 'admin_mirempet';

  columns: TableColumn[] = [
    {
      header: 'Nome Completo',
      valueGetter: (row: any) =>
        `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim(),
    },
    { field: 'username', header: 'Nome de Usuário' },
    { field: 'email', header: 'Email' },
    { field: 'gender', header: 'Género' },
    {
      field: 'enabled',
      header: 'Estado',
      type: 'tag',
      formatter: (value: boolean) => (value ? 'Activo' : 'Desactivado'),
      tagSeverityFunction: (row: any) => (row.enabled ? 'success' : 'danger'),
    },
  ];

  listageneros = [
    { id: 'Masculino', designacao: 'Masculino' },
    { id: 'Feminino', designacao: 'Feminino' },
  ];

  estadoOptions = [
    { id: '1', designacao: 'Activo' },
    { id: '2', designacao: 'Desactivado' },
  ];

  listaPortais = [
    { id: 'admin_mirempet', designacao: 'Portal MIREMPET' },
    { id: 'admin_empresa', designacao: 'Portal Empresas' },
    { id: '', designacao: 'Portal de Estudantes' },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'Nome',
      placeholder: 'Nome do utilizador',
    },
    {
      type: 'text',
      controlName: 'email',
      placeholder: 'Email do utilizador',
    },
    {
      type: 'dropdown',
      controlName: 'gender',
      placeholder: 'Género',
      options: this.listageneros,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Estado',
      placeholder: 'Estado',
      options: this.estadoOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'role',
      placeholder: 'Portal',
      options: this.listaPortais,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  actions: ((rowData: any) => MenuItem[]) | MenuItem[] = [
    {
      id: 'associate',
      label: 'Associar Grupo',
      icon: 'pi pi-link',
      command: ($event: any) => this.openAssociateModal($event.item.data),
    },
    {
      id: 'disassociate',
      label: 'Desassociar de um Grupo',
      icon: 'pi pi-user-minus',
      command: ($event: any) => this.openDisassociateModal($event.item.data),
    },
    {
      id: 'toggleStatus',
      label: 'Habilitar utilizador',
      icon: 'pi pi-user-plus',
      command: ($event: any) => this.toggleStatusUser($event.item.data),
    },
    {
      id: 'recoveryPassword',
      label: 'Redefinir Palavra-Passe',
      icon: 'pi pi-key',
      command: ($event: any) =>
        this.showModalRecoveryPassword($event.item.data),
    },
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
    this.loadUsers();
    this.loadAndFilterGroups();
    this.actions = (user: MenuItem) => this.getMenuActions(user);

    this.formNewUser = this.fb.group(
      {
        numeroBI: [null, Validators.required],
        email: [null, Validators.required],
        senha: [
          null,
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
        ],
        senhaConfirm: [null, Validators.required],
        groupId: [null, Validators.required],
      },
      {
        validator: this.passwordMatchValidator('senha', 'senhaConfirm'),
      },
    );

    this.formRecoveryPassword = this.fb.group(
      {
        Username: [{ value: '', disabled: true }, Validators.required],
        email: [{ value: '', disabled: true }, Validators.required],
        novasenha: [
          null,
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
        ],
        novasenhaConfirm: [null, Validators.required],
      },
      {
        validator: this.passwordMatchValidator('novasenha', 'novasenhaConfirm'),
      },
    );
  }

  passwordMatchValidator(senha: string, senhaConfirm: string) {
    return (formNewUser: FormGroup) => {
      const passwordControl = formNewUser.get(senha);
      const confirmPasswordControl = formNewUser.get(senhaConfirm);

      if (!passwordControl || !confirmPasswordControl) return;

      // Só seta erro de mismatch se ambos estiverem preenchidos
      if (
        confirmPasswordControl.value &&
        passwordControl.value !== confirmPasswordControl.value
      ) {
        confirmPasswordControl.setErrors({
          ...confirmPasswordControl.errors,
          passwordMismatch: true,
        });
      } else {
        if (confirmPasswordControl.errors) {
          delete confirmPasswordControl.errors['passwordMismatch'];
          if (Object.keys(confirmPasswordControl.errors).length === 0) {
            confirmPasswordControl.setErrors(null);
          } else {
            confirmPasswordControl.setErrors(confirmPasswordControl.errors);
          }
        }
      }
    };
  }

  private initForm(): void {
    this.associateForm = this.fb.group({
      username: [{ value: '', disabled: true }, Validators.required],
      groupId: [null, Validators.required],
    });

    this.form = this.fb.group({
      Nome: [null],
      email: [null],
      gender: [null],
      Estado: [null],
      role: [this.FILTER_ROLE],
    });

    this.dissassociateForm = this.fb.group({
      username: [{ value: '', disabled: true }, Validators.required],
      groupId: [null, Validators.required],
    });
  }

  showModalFilter(): void {
    this.showFilter = true;
  }

  ShowAddUser(): void {
    this.ShowNewUser = true;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadUsers();
  }

  private loadUsers(filters?: any): void {
    this.isLoading = true;

    const rawParams = {
      ...filters,
      pageNumber: this.pagination.pageNumber || 1,
      pageSize: this.pagination.pageSize ?? 10,
      ...this.form.value,
    };

    const params = Object.fromEntries(
      Object.entries(rawParams).filter(
        ([_, value]) => value != null && value !== '',
      ),
    );

    this.permissionService
      .listUser(params)
      .pipe(
        take(1),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe({
        next: (res) => this.handleUserResponse(res),
        error: (err) => this.handleError('Erro ao buscar utilizadores', err),
      });
  }

  private handleUserResponse(response: any): void {
    this.pagination = new Pagination<any>().deserialize(response);
    const total = response.totalRecords;
    this.totalRecordsChange.emit(total);

    const records = response.data.map((user: any) => ({
      ...user,
      nome: user.firstName,
    }));

    this.users = records;

    this.pagination = this.pagination.deserialize({
      ...response,
      data: records,
    });
  }

  getMenuActions(user: any): MenuItem[] {
    const toggleLabel = user.enabled
      ? 'Desabilitar utilizador'
      : 'Habilitar utilizador';
    const toggleIcon = user.enabled ? 'pi pi-user-minus' : 'pi pi-user-plus';
    const toggleCommand = () => this.toggleStatusUser(user);

    return [
      {
        id: 'associate',
        label: 'Associar Grupo',
        icon: 'pi pi-link',
        command: () => this.openAssociateModal(user),
      },
      {
        id: 'disassociate',
        label: 'Desassociar de um Grupo',
        icon: 'pi pi-user-minus',
        command: () => this.openDisassociateModal(user),
      },
      {
        id: 'toggleStatus',
        label: toggleLabel,
        icon: toggleIcon,
        command: toggleCommand,
      },
      {
        id: 'recoveryPassword',
        label: 'Redefinir Palavra-Passe',
        icon: 'pi pi-key',
        command: () => this.showModalRecoveryPassword(user),
      },
    ];
  }

  toggleStatusUser(user: any): void {
    const acao = user.enabled ? 'desabilitar' : 'habilitar';
    const novoEstado = !user.enabled;

    this.confirmationService.confirm({
      message: `Tens a certeza que desejas ${acao} o utilizador <strong>${user.nome}</strong>?`,
      header: 'Confirmar Ação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const toggle$ = novoEstado
          ? this.permissionService.habilitarUser(user.username)
          : this.permissionService.desabilitarUser(user.username);

        toggle$.pipe(take(1)).subscribe({
          next: () => {
            user.enabled = novoEstado;
            this.loadUsers();
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: `Utilizador ${
                user.enabled ? 'habilitado' : 'desabilitado'
              } com sucesso.`,
            });
            this.confirmationService.close();
          },
          error: (err) => {
            this.handleError('Erro ao alterar estado do utilizador', err);
            this.confirmationService.close();
          },
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: `Ação de ${acao} cancelada.`,
        });
        this.confirmationService.close();
      },
    });
  }

  private handleError(summary: string, error: any): void {
    console.error(summary, error);
    this.messageService.add({ severity: 'error', summary, detail: summary });
  }

  private openAssociateModal(user: UserRecord): void {
    this.selectedUser = user;
    this.showModalAssociate = true;
    this.associateForm.patchValue({ username: user.username, groupId: null });
  }

  private loadAndFilterGroups(): void {
    const ocultos = new Set([
      'ADMIN_EMPRESA',
      'ADMIN_MIREMPET',
      'Acordo de Formação',
      'Auxilio de Formação',
      'Cursos',
      'Dashboard',
      'Empresa Gestora',
      'Estudantes',
      'Instituições de Ensino',
      'Profissionais',
      'Relatórios',
    ]);

    this.permissionService
      .list({
        PageNumber: 1,
        PageSize: 1000,
      })
      .pipe(
        take(1),
        map((res: any) =>
          res.data.map((g: any) => ({ id: g.id, nomeGrupo: g.name })),
        ),
        // map((groups) => groups.filter((g: any) => !ocultos.has(g.nomeGrupo)))
      )
      .subscribe({
        next: (groups) => (this.listGrupos = groups),
        // error: (err) => this.handleError('Erro ao buscar grupos', err),
      });
  }

  saveUser(): void {
    if (this.associateForm.invalid || !this.selectedUser) {
      this.associateForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
      return;
    }
    const { username, groupId } = this.associateForm.getRawValue();
    this.permissionService
      .atribuirUser({ username, groupId })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Usuário associado com sucesso.',
          });
          this.closeAssociateModal();
        },
        error: (err) => this.handleError('Falha ao associar usuário', err),
      });
  }

  cancel(): void {
    this.closeAssociateModal();
  }
  showDesassociateModal: boolean = false;

  private openDisassociateModal(user: UserRecord): void {
    this.showDesassociateModal = true;
    this.selectedUser = user;
    this.permissionService
      .listGroupsByUsername(user.username)
      .pipe(take(1))
      .subscribe({
        next: (groups) => {
          this.listGroupsByUser = groups.data.map((g: any) => ({
            id: g.id,
            nomeGrupo: g.name,
          }));
          this.dissassociateForm.patchValue({
            username: user.username,
            groupId: groups.length > 0 ? groups[0].id : null,
          });
        },
        error: (err) =>
          this.handleError('Erro ao buscar grupos do usuário', err),
      });
    this.dissassociateForm.patchValue({
      username: user.username,
      groupId: null,
    });
  }

  trackByGroup = (_: number, group: GroupOption) => group.id;

  RemoveUserFromGroup(
    username: string,
    groupId: string,
    nomeGrupo: string,
  ): void {
    if (!username || !groupId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Dados inválidos para desassociação.',
      });
      return;
    }

    this.confirmationService.confirm({
      message: `Tem certeza que deseja remover o usuário <strong>${username}</strong> do grupo <strong>${nomeGrupo}</strong>?`,
      header: 'Confirmar Remoção',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.showDesassociateModal = false;
        this.dissassociateForm.reset();
        this.permissionService
          .desassociarUser({ username, groupId })
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Usuário removido do grupo "${nomeGrupo}" com sucesso.`,
              });
              this.confirmationService.close();
              this.listGroupsByUser = this.listGroupsByUser.filter(
                (g) => g.id !== groupId,
              );
            },
            error: (err) => {
              this.handleError('Falha ao desassociar usuário', err);
            },
          });
      },
      reject: () => {
        this.showDesassociateModal = false;
        this.dissassociateForm.reset();
        this.confirmationService.close();
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: 'Desassociação cancelada.',
        });
      },
    });
  }

  private closeAssociateModal(): void {
    this.showModalAssociate = false;
    this.associateForm.reset();
    this.selectedUser = undefined;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.loadUsers(filters);
    this.showFilter = false;
  }

  searchDocumentNumber() {
    this.authService
      .consultarBi(this.formNewUser.get('numeroBI')?.value)
      .subscribe((result) => {
        if (result.retorno.codigo == 200 && result.data) {
          this.userName = result.data.nome + ' ' + result.data.sobrenome;
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Cidadão encontrado com sucesso.',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              'Não foi possivel encontrar o cidadão com o número do BI fornecido.',
            life: 4000,
          });
        }
      });
  }

  createUser(): void {
    if (this.formNewUser.invalid) {
      this.formNewUser.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail:
          'Formulário inválido. Por favor, preencha todos os campos obrigatórios corretamente.',
      });
      return;
    }

    if (!this.formNewUser.get('numeroBI')?.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail:
          'Por favor, pesquise pelo número do BI antes de criar o perfil.',
        life: 4000,
      });
      return;
    }

    const payoad = {
      username: this.formNewUser.get('numeroBI')?.value,
      firstName: this.userName.split(' ')[0],
      lastName: this.userName.split(' ').slice(1).join(' '),
      email: this.formNewUser.get('email')?.value,
      password: this.formNewUser.get('senha')?.value,
      groupId: this.formNewUser.get('groupId')?.value,
    };

    if (payoad.password !== this.formNewUser.get('senhaConfirm')?.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'As senhas não coincidem. Por favor, verifique.',
      });
      return;
    }

    this.permissionService
      .createUser(payoad)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Utilizador criado com sucesso.',
          });
          this.ShowNewUser = false;
          this.formNewUser.reset();
          this.userName = '';
          this.loadUsers();
        },
        error: (err) => {
          this.handleError('Erro ao criar utilizador', err);
        },
      });
  }

  usernameRecovery: string = '';
  emailRecovery: string = '';
  novasenhaRecovery: string = '';

  showModalRecoveryPassword(user: any): void {
    this.ShowRecoveryPassword = true;
    this.formRecoveryPassword.patchValue({
      Username: user.username,
      email: user.email,
    });
    this.usernameRecovery = user.username;
    this.emailRecovery = user.email;
  }

  recoveryPassword(): void {
    this.novasenhaRecovery = this.formRecoveryPassword.get('novasenha')?.value;

    if (this.formRecoveryPassword.invalid) {
      this.formRecoveryPassword.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
      return;
    }

    this.permissionService
      .recoveryPassword(
        this.usernameRecovery,
        this.emailRecovery,
        this.novasenhaRecovery,
      )
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Senha redefinida com sucesso.',
          });
          this.ShowRecoveryPassword = false;
          this.formRecoveryPassword.reset();
          this.loadUsers();
        },
        error: (err) => {
          this.handleError('Erro ao redefinir senha', err);
        },
      });
  }
}
